import { t } from 'i18next'
import { config, DEV } from '../config/config'
import { RU } from '../locale/languages'
import { LOGIN } from '../routes/app-routes'
import { APP_BAR_STORE, USER_STORE, APP_STORE } from '../store/stores'
import { getStore } from '../store/stores-repository'
import { prepareLocale } from './locale-utils'
import { goTo, getBaseURL } from './router-utils'
import { GET } from './client-server/method-types'
import { ALL_SERVICES } from '../api/all-services'

/**
 * Объект для разрыва связи es6 модулей, чтобы решить проблему циклических зависимостей
 * appRenderer.render просто отрисовывает приложение, подменяется заказчиком
 *
 * @type {{renderRoutes: () => null}}
 */
export const appRenderer = {
    render: () => null
}

export async function loadConfig() {
    config.environment = global.build.environment || DEV
    config.baseURL = getBaseURL()

    const showConfig = () => {
        console.info('app config:')
        console.info(` - environment: ${config.environment}`)
        console.info(` - baseURL: ${config.baseURL}`)
        console.info(` - serverHost:  ${config.serverHost}`)
        console.info(` - serverPort:  ${config.serverPort}`)
    }

    try {
        const getConfigResponse = await fetch(`${config.baseURL}/config.json?${Date.now()}`, { method: GET })

        const configJSON = await getConfigResponse.json()

        if (configJSON.status < 200 || configJSON.status > 299) {
            const errorMessage = `loading config failed, status: ${configJSON.status}`
            console.error(errorMessage)
            throw new Error(errorMessage)
        } else {
            config.serverHost = configJSON.serverHost
            config.serverPort = configJSON.serverPort
        }
    } catch (error) {
        console.error('config not found:', error)

        config.serverHost = window.location.hostname
        config.serverPort = window.location.port
    }

    showConfig()

    return config
}

export async function setServicesServerAddress() {
    ALL_SERVICES.forEach(service => {
        service.serverAddress = config.serverAddress
    })
}

export const preAuthLogic = async () => {
    const appStore = getStore(APP_STORE)
    // Загружаем конфиг
    await loadConfig()
    // Инициализация devTools
    appStore.setDevTools()
    // Задаём базовый адрес для сервисов
    await setServicesServerAddress()
    // Подготавливаем локализацию
    await prepareLocale(RU)
    // Указываем title из локализации
    document.title = t('setMark.title')
    // Первичный рендеринг роутов
    appRenderer.render()
}

export const checkAuth = () => {
    const userStore = getStore(USER_STORE)

    if (!userStore.authorized) {
        goTo(LOGIN)
        throw new Error('Authentication error')
    }
}

export const postAuthLogic = () => {
    const userStore = getStore(USER_STORE)
    const appBarStore = getStore(APP_BAR_STORE)

    if (!userStore.authorized) {
        return
    }

    // Необходимо обновить доступные пользователю роуты
    appRenderer.render()
    // Запускаем отслеживание изменения роутов
    appBarStore.startRouteWatching()
}

export const appLaunchChain = async () => {
    await preAuthLogic()
    checkAuth()
    postAuthLogic()
}
